import Filters from 'components/filters';
import Pagination from 'components/pagination';
import {default as React} from 'react';

import {Grid} from '@material-ui/core';
import {autobind} from 'core-decorators';
import {
    addQueryParams, getCurrentPage, getMaxPage, getPageFromQS, parseQueryString
} from 'core/utils';
import supervisorHomeQuery from 'graphql/queries/supervisor-home.gql';
import PropTypes from 'prop-types';
import {withApollo} from 'react-apollo';
import AccruedExpenditure from './accrued-expenditure';
import Banners from './banners';
import ExpenditureByOrganization from './expenditure-by-organization';
import Statistics from './statistics';
import styles from './styles.css';

@withApollo
@autobind
export default class SupervisorHome extends React.Component {
    static contextTypes = {
        router: PropTypes.object,
    };

    state = {
        loading: true,
        creditsByOrganization: [],
    };

    pageSize = 40;

    componentDidMount() {
        this.load(this.props.location.search);
    }
    componentWillReceiveProps(nextProps) {
        this.load(nextProps.location.search);
    }

    async handleFilterChange(filters, resetPage = false) {
        const {history} = this.context.router;
        const oldParams = parseQueryString(this.props.location.search) || {};
        const page = resetPage ? 0 : getPageFromQS(oldParams, filters);
        addQueryParams({...filters, page}, history, this.props.location);
    }

    async load(locationProps) {
        const filters = parseQueryString(locationProps) || {};
        const page = !!filters.page ? filters.page : 0;
        this.setState({loading: true});
        const response = await this.makeRequest({...filters, page, pageSize: this.pageSize});
        await this.setState({
            creditSummary: response.data && response.data.creditSummary,
            countsByCategory: response.data && response.data.countsByCategory,
            creditsByOrganization: response.data && response.data.creditsByOrganization,
            transactionsByCategory: response.data && response.data.transactionsByCategory,
            season: filters.season,
            loading: false,
            count: response.data && response.data.creditsByOrganizationCount,
        });
    }

    async makeRequest(filters) {
        const response = await this.props.client.query({
            fetchPolicy: 'network-only',
            query: supervisorHomeQuery,
            variables: {
                season: filters.season || undefined,
                region: filters.region || undefined,
                salesUser: filters.salesUser || undefined,
                organizationCategory: filters.organizationCategory || undefined,
                organization: filters.organization || undefined,
                pageSize: this.pageSize,
                page: filters.page,
            },
        });
        return response;
    }

    handlePreviousPage(page) {
        return () => {
            if (page >= 0) this.handleFilterChange({page: page - 1});
        };
    }

    handleNextPage(page, maxPage) {
        return () => {
            if (page <= maxPage) this.handleFilterChange({page: page + 1});
        };
    }

    handlePageClick(number) {
        this.handleFilterChange({page: number});
    }

    render() {
        const {count} = this.state;
        const page = getCurrentPage(this.props.location);
        const maxPage = getMaxPage(count, this.pageSize);
        return (
            <div className={styles.root}>
                <div className={styles.background} />
                <div className={styles.adminPanel}>
                    <Filters
                        filters={[
                            'season',
                            'region',
                            'salesUser',
                            'organizationCategory',
                            'organization',
                        ]}
                        onChange={(params) => this.handleFilterChange(params, true)}
                    />
                    {!this.state.loading && (
                        <Grid container spacing={4}>
                            <Grid item xs={12}>
                                <AccruedExpenditure
                                    creditSummary={this.state.creditSummary}
                                    transactionsByCategory={this.state.transactionsByCategory}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Banners />
                            </Grid>
                            <Grid item xs={12}>
                                <Statistics statistics={this.state.countsByCategory} />
                            </Grid>
                        </Grid>
                    )}
                </div>
                {!this.state.loading && (
                    <ExpenditureByOrganization
                        season={this.state.season}
                        expenditureByOrganization={this.state.creditsByOrganization}
                    />
                )}
                {maxPage > 0 && (
                    <Pagination
                        maxPage={maxPage}
                        active={page}
                        handlePreviousPage={this.handlePreviousPage(page)}
                        handleNextPage={this.handleNextPage(page, maxPage)}
                        handlePageClick={this.handlePageClick}
                    />
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/home/supervisor-home/index.js